import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询列表
export function query(requestBody) {
  return request({
    url: URL.finance.fiscalPeriod.query,
    method: 'post',
    data: requestBody
  })
}

// 获取账套的会计期间
export function getCurrentFiscalPeriod(requestBody) {
  return request({
    url: URL.finance.fiscalPeriod.getCurrentFiscalPeriod,
    method: 'post',
    data: requestBody
  })
}

// 获取详情
export function detail(requestBody) {
  return request({
    url: URL.finance.fiscalPeriod.detail,
    method: 'post',
    data: requestBody
  })
}

// 新增/修改保存
export function save(requestBody) {
  return request({
    url: URL.finance.fiscalPeriod.save,
    method: 'post',
    data: requestBody
  })
}

// 删除
export function remove(requestBody) {
  return request({
    url: URL.finance.fiscalPeriod.remove,
    method: 'post',
    data: requestBody
  })
}

// 创建财务期间
export function createNewFiscalPeriod(requestBody) {
  return request({
    url: URL.finance.fiscalPeriod.createNewFiscalPeriod,
    method: 'post',
    data: requestBody
  })
}

// 结账
export function closingFiscalPeriod(requestBody) {
  return request({
    url: URL.finance.fiscalPeriod.closingFiscalPeriod,
    method: 'post',
    data: requestBody
  })
}

// 反结账
export function openFiscalPeriod(requestBody) {
  return request({
    url: URL.finance.fiscalPeriod.openFiscalPeriod,
    method: 'post',
    data: requestBody
  })
}
